<template>
    <app-layout>
        <template #header>
            <div class="relative flex justify-between items-center">
                <div>
                    <h2 class=" font-bold text-xl leading-tight">
                    <i class="fas fa-hand-holding-usd"></i>
                        Enviar
                    </h2>
                </div>
                <Balance :short="true"/>
            </div>
        </template>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <section class="mx-4 xl:mx-32 lg:mx-20 md:mx-3 xl:mt-16 lg:mt-16 md:mt-6 sm:mt-6 mt-4">
                <Slider :stages="sliderStages" />
                <div class="px-1 lg:px-5">
                    <payments
                        v-show="sections.payments"
                        @next="next"
                    />
                    <value-details
                        v-if="sections.valueDetails"
                        :payments="payments"
                        @go-back="goBack"
                    />
                </div>
            </section>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../../../Layouts/AppLayout.vue";
import Slider from "../../components/Slider.vue";
import Balance from "../../../../Helpers/Balance.vue";
import Payments from "./Payments.vue";
import ValueDetails from "./ValueDetails.vue";

export default {
    name: "SendLotsTed",
    data(){
        return {
            sections: {
                payments: true,
                valueDetails: false
            },
            payments: []
        }
    },
    computed: {
        sliderStages(){
            return [{
                    titleStage: 'Modalidade de envio',
                    percentage: '0%',
                    selected: false,
                    completed: true
                },
                {
                    titleStage: 'Pagamentos',
                    percentage: '50%',
                    selected: this.sections.payments,
                    completed: this.sections.valueDetails,
                },
                {
                    titleStage: 'Valor e detalhes',
                    percentage: '98.7%',
                    selected: this.sections.valueDetails,
                    completed: this.sections.valueDetails,
                }]
        }
    },
    methods: {
        goBack(){
            this.sections.payments = true
            this.sections.valueDetails = false
        },
        next(payments){
            this.payments = payments
            this.sections.payments = false
            this.sections.valueDetails = true
        },
    },
    components: {
        AppLayout,
        Slider,
        Balance,
        Payments,
        ValueDetails
    }
};
</script>
